import React, { createContext, useState, useEffect } from "react";
import { fetchXp, fetchLevel } from "../apiHandles/user_progress";

export const UserProgressContext = createContext();

export const UserProgressProvider = ({ children }) => {
    const [xp, setXp] = useState(0);
    const [level, setLevel] = useState(1);
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const fetchedXp = (await fetchXp()) || 0;
                const fetchedLevel = (await fetchLevel()) || 1;

                setXp(fetchedXp);
                setLevel(fetchedLevel);
                setIsInitialized(true);
            } catch (error) {
                console.error("Error fetching user progress:", error);
                // Set defaults even on error
                setXp(0);
                setLevel(1);
                setIsInitialized(true);
            }
        };
        fetchData();
    }, []);

    const updateXp = (newXp) => {
        setXp(newXp);
    };

    const updateLevel = (newLevel) => {
        setLevel(newLevel);
    };

    return (
        <UserProgressContext.Provider value={{
            xp,
            level,
            isInitialized,
            updateXp,
            updateLevel
        }}>
            {children}
        </UserProgressContext.Provider>
    );
};